import React from "react"
import Layout from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Layout"
import SEO from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Seo"
import BodyBlocks from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BodyBlocks"
import HeroBlock from "@yumgmbh/gatsby-theme-yum-components/src/components/blocks/HeroBlock"
import Breadcrumbs from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Breadcrumbs"
import ShortLinkNav from "../../../../components/modules/ShortLinkNav"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"

const HeroPage = ({ content, name, breadcrumbs, language }) => {
  return (
    <Layout language={language}>
      <SEO content={content} name={name} />
      <Breadcrumbs
        textColor={
          content?.image?.filename?.length > 0
            ? "text-white drop-shadow"
            : "text-gray-500"
        }
        breadcrumbs={breadcrumbs}
      ></Breadcrumbs>
      {content?.image?.filename?.length > 0 ? (
        <HeroBlock
          block={{
            image: content.image,
            kicker: content.kicker,
            headline: content.headline,
            subheadline: content.subheadline,
            logo: content.logo,
            buttons: content.buttons,
          }}
        />
      ) : (
        <BlockWrapper block={{}} blockPadding="pt-12 pb-0">
          <HeadlineEnhanced headline={content.headline} headlineLevel="h1" />
        </BlockWrapper>
      )}

      {content?.short_link_nav?.length > 0 && (
        <ShortLinkNav links={content.short_link_nav} />
      )}
      <BodyBlocks body={content.body} />
    </Layout>
  )
}

export default HeroPage
